import bmr from './bmr';

import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export default new Vuex.Store({
    modules: {
        bmr
    }
});



// WEBPACK FOOTER //
// ./src/store/index.js